import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  AllowedOptionsState,
  AllowedOptionDTO
} from "../../../types/settings/allowedOptionsInterfaces";

const initialState: AllowedOptionsState = {
  codes: {},     
  grouped: {},
};

export const allowedOptionsSlice = createSlice({
  name: "allowedOptions",
  initialState,
  reducers: {
    setCodes: (
      state,
      action: PayloadAction<{ module: string; target: string; codes: string[] }>
    ) => {
      const key = `${action.payload.module}-${action.payload.target}`;
      state.codes[key] = action.payload.codes;
    },

    resetCodes: (state) => {
      state.codes = {};
    },
    setGrouped: (
      state,
      action: PayloadAction<Record<string, Record<string, AllowedOptionDTO[]>>>
    ) => {
      state.grouped = action.payload;
    },
    updateSingleInGrouped: (state, action: PayloadAction<AllowedOptionDTO>) => {
      const { module, target, code } = action.payload;
      const targetList = state.grouped?.[module]?.[target];
      if (!targetList) return;

      const index = targetList.findIndex((opt) => opt.code === code);
      if (index !== -1) {
        targetList[index] = action.payload;
      }
    },
    updateMultipleInGrouped: (
      state,
      action: PayloadAction<AllowedOptionDTO[]>
    ) => {
      action.payload.forEach((updatedOption) => {
        const { module, target, code } = updatedOption;
        const list = state.grouped?.[module]?.[target];
        if (!list) return;

        const index = list.findIndex((opt) => opt.code === code);
        if (index !== -1) {
          list[index] = updatedOption;
        }
      });
    },
  },
});

export const {
  setCodes,
  resetCodes,
  setGrouped,
  updateSingleInGrouped,
  updateMultipleInGrouped,
} = allowedOptionsSlice.actions;

export default allowedOptionsSlice.reducer;
